

































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component
export default class CGVPopup extends Vue {
    @Prop({ default: false }) active!: boolean;

    isActive: boolean = this.active;
    termsAndConditions: boolean = false;
    scrolledToBottom: boolean = false;
    scrollProgress: number = 0;

    @Watch('active')
    onActivePropChange(val: boolean) {
        this.isActive = val;
        if (val) {
            this.termsAndConditions = false;
            this.scrolledToBottom = false;
            this.scrollProgress = 0;
        }
    }

    onScroll(event: Event) {
        const target = event.target as HTMLElement;
        const scrolled = target.scrollTop;
        const total = target.scrollHeight - target.clientHeight;
        if (total > 0) {
            this.scrollProgress = Math.min(100, (scrolled / total) * 100);
        }
        if (scrolled >= total - 10) {
            this.scrolledToBottom = true;
        }
    }

    onCheckboxChange() {
        if (!this.scrolledToBottom) {
            this.termsAndConditions = false;
        }
    }

    accept() {
        if (this.termsAndConditions) {
            this.$emit('accept', true);
            this.$emit('update:active', false);
            this.isActive = false;
        }
    }

    close() {
        this.$emit('update:active', false);
        this.isActive = false;
    }
}
